module.exports = __webpack_public_path__ + "img/imagen1.6be04f57.jpg";